module.exports = __webpack_public_path__ + "static/media/kovan.d0632f1b.svg";